package com.macrofocus.eflux.deckgl

import org.locationtech.jts.geom.Coordinate
import org.locationtech.jts.geom.LineString
import org.locationtech.jts.geom.Point
import org.locationtech.jts.geom.Polygon

fun LineString.toJSonArray(): Array<Array<Double>> {
    return Array(numPoints) { i ->
        val point = getPointN(i)
        arrayOf(point.x, point.y)
    }
}

fun Polygon.toJSonArray(): Array<Array<Double>> {
    return Array(numPoints) { i ->
        val point = exteriorRing!!.getPointN(i)
        arrayOf(point.x, point.y)
    }
}

fun Coordinate.toJSonArray(): Array<Double> {
    return arrayOf(x, y)
}

fun Point.toJSonArray(): Array<Double> {
    return arrayOf(x, y)
}
